<template>
  <div>
    <font-awesome-layers full-width >
      <font-awesome-icon icon="sticky-note" class="fa-xl"/>
      <font-awesome-layers-text
          v-if="numberOfStickyNotes"
          :value="numberOfStickyNotes"
          transform="down-3 left-5 shrink-5"
          class="fa-layers-top-left fa-layers-counter"
          style="background-color: green"/>
    </font-awesome-layers>
  </div>
</template>

<script>
import StickyNote from "@/server/com/silkplm/model/sticky/StickyNote";

export default {
  name: "StickyNoteIcon",

  async beforeMount() {
    await this.countStickyNotes();
  },

  async mounted() {
    this.$onInsert(StickyNote, async (changeEvent) => {
      this.numberOfStickyNotes++;
    });

    this.$onDelete(StickyNote, async (changeEvent) => {
      this.numberOfStickyNotes--;
    });

    this.$onBulkChange(StickyNote, async (changeEvent) => {
      await this.countStickyNotes();
    });
  },


  methods: {

    async countStickyNotes(){
      this.numberOfStickyNotes = await Rpc.StickyNotes.getNumberOfStickyNotes();
    },

  },

  props: {

  },


  data: () => ({
    numberOfStickyNotes: 0,
  }),
}
</script>

<style scoped>

</style>